import PropTypes from "prop-types";
import React from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTranslate } from "react-polyglot";
import { makeStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import CustomPrimaryButton from "../../../../../SharedComponents/CustomPrimaryButton.jsx";
import CustomGreyButton from "../../../../../SharedComponents/CustomGreyButton.jsx";
import CustomTransparentButtom from "../../../../../SharedComponents/CustomTransparentButtom.jsx";
import FlexboxVertical from "../../../../../SharedComponents/FlexboxVertical.jsx";
import { Actions, Content, Title } from "../../SharedComponents/ExamPopup.jsx";
import NewTimerChip from "../../../../../SharedComponents/NewTimerChip.jsx";
import { formatTime } from "../../../../../Utils/misc.js";
import QuadraticProgress from "../../../../../SharedComponents/QuadraticProgress.jsx";
import ExamStatusText from "../../../../../SharedComponents/ExamStatusText.jsx";

const useStyles = makeStyles(() => ({
  mainBox: {
    "& .MuiPaper-root": {
      borderRadius: 16,
    },
  },
  examInfo: {
    alignItems: "center",
  },
  progress: {
    margin: "20px 0",
    width: 90,
    height: 90,
    borderRadius: 22,
    boxShadow: "0 0 16.53px rgba(0, 0, 0, 0.12)",
  },
  resultText: {
    color: "#49454F",
  },
}));

/**
 * @param {Boolean} open
 * @param {ExamPopup.OnClose} onClose
 * @param {Exam} exam
 */
const ExamResultPopup = ({ open, onClose, exam }) => {
  const classes = useStyles();
  const t = useTranslate();

  /** */
  const cancel = () => {
    onClose("close");
  };

  return (
    <Dialog open={open} onClose={cancel} maxWidth="sm" fullWidth className={classes.mainBox}>
      <Title disableTypography>
        {exam.endDate && <NewTimerChip label={formatTime((exam.endDate - exam.startDate) / 1000)} />}
        <ExamStatusText exam={exam} />
      </Title>
      <Content>
        <FlexboxVertical className={classes.examInfo}>
          <Typography className={classes.resultText} variant="h6">
            {t("exam.result")}
          </Typography>
          <QuadraticProgress
            className={classes.progress}
            value={(exam.points / exam.totalPoints) * 100}
            textValue={`${exam.points}/${exam.totalPoints}`}
          />
        </FlexboxVertical>
      </Content>
      <Actions>
        {exam.numberOfAttempts > 0 && (
          <CustomPrimaryButton onClick={() => onClose("retake")}>
            {t("exam.retakeButton", { smart_count: exam.numberOfAttempts })}
          </CustomPrimaryButton>
        )}
        <CustomGreyButton onClick={() => onClose("view")}>{t("exam.viewButton")}</CustomGreyButton>
        <CustomTransparentButtom onClick={cancel}>{t("exam.closeButton")}</CustomTransparentButtom>
      </Actions>
    </Dialog>
  );
};

ExamResultPopup.propTypes = {
  exam: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default ExamResultPopup;
